import { Stack } from '@mui/material';
import styled from 'styled-components';

export const QRCodeContainer = styled(Stack)`
  && {
    align-items: center;
    border: 0.5rem solid white;
    border-radius: ${({ theme }) => theme.shape.containerRadius};
  }
`;
